import { Component } from "react";

import { SYNC_SERVICE, DATE_FORMATS } from '../global/Constants';
import Dexie from 'dexie';
import Moment from 'moment';
import { ActivityStatusType, ActivityType, S2S_STAGE } from "../global/Enum";
import Utilities from "../global/Utilities";
import { v4 as uuidv4 } from 'uuid';
import AuthService from './AuthService';
import ApiServices from "./ApiServices";

let dexie;

export default class SyncServices extends Component {
    static myInstance = null;
    static masterCount = 0;
    static krishakCount = 0;
    static activityCount = 0;

    static getInstance() {
        if (SyncServices.myInstance == null) {
            SyncServices.myInstance = new SyncServices()
        }
        return this.myInstance;
    }

    static setDatabase() {
        dexie = new Dexie(SYNC_SERVICE.DATABASE_NAME);

        let objectDexie = {
            [SYNC_SERVICE.MASTER_TABLE]: "key, is_synced",
            [SYNC_SERVICE.KRISHAK_TABLE]: "key, is_synced, is_prerak, krishak_id, temp_krishak_id",
            [SYNC_SERVICE.KRISHAK_IMAGE_TABLE]: "key, is_synced",
            [SYNC_SERVICE.ACTIVITY_TABLE]: "key, activity_id, activity_type_id, activity_status_id, employee_id, created_at, is_synced",
            [SYNC_SERVICE.USER_ACTIVITY_TABLE]: "key, date",
        };

        dexie.version(1).stores(objectDexie);
        dexie.open().catch((err) => {
            Utilities.LogPrint(err.stack || err)
        })
    }

    static addMasterToDatabase(data, key) {
        //Utilities.LogPrint("addMasterToDatabase", data);
        dexie.Master.put({ key, data, lastSyncDate: new Date(), is_synced: "true" });
    }

    static updateKrishakToDatabase(data, key, is_prerak, krishak_id, temp_krishak_id) {
        Utilities.LogPrint("updateKrishakToDatabase", data);
        dexie.Krishak.put({ key, data, is_prerak, lastSyncDate: "", is_synced: "false", temp_krishak_id, krishak_id });
    }

    static addKrishakToDatabase(data, key, is_prerak, krishak_id, temp_krishak_id) {
        //Utilities.LogPrint("addKrishakToDatabase", data);
        dexie.Krishak.put({ key, data, is_prerak, lastSyncDate: new Date(), is_synced: "true", krishak_id, temp_krishak_id });
    }

    static addKrishakImageToDatabase(data, key) {
        //Utilities.LogPrint("addKrishakImageToDatabase", data);
        if (key) {
            key = key.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        } else {
            key = "null"
        }

        try {
            dexie.KrishakImages.put({ key, data, lastSyncDate: new Date(), is_synced: "false" });
        } catch (error) {
            //Utilities.LogPrint("addKrishakImageToDatabase:error", error);
        }
    }

    static async getKrishakFromDatabase(key, value) {
        return await dexie.Krishak.where(key).equalsIgnoreCase(value).toArray().then(function (result) {
            // Utilities.LogPrint("getDataFromKrishak", result);
            return (result && result.length > 0 && result !== undefined) ? result : null;
        });
    }

    static async getAllKrishakImagesFromDatabase() {
        return await dexie.KrishakImages.where("is_synced").equalsIgnoreCase("false").toArray().then(function (result) {
            //Utilities.LogPrint("getAllKrishakImagesFromDatabase", result);
            return (result && result.length > 0 && result !== undefined) ? result : null;
        });
    }

    static async findKrishakFromDatabase(key, value) {
        return await dexie.Krishak.where(key).equalsIgnoreCase(value).toArray().then(function (result) {
            //Utilities.LogPrint("getDataFromKrishak", result);
            return (result && result.length > 0 && result !== undefined) ? result[0].data : null;
        });
    }

    static async findKrishakImageFromDatabase(key, value) {
        //Utilities.LogPrint("findKrishakImageFromDatabase", value);
        if (value) {
            value = value.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        } else {
            value = "null"
        }

        return await dexie.KrishakImages.where(key).equalsIgnoreCase(value).toArray().then(function (result) {
            Utilities.LogPrint("findKrishakImageFromDatabase", result);
            return (result && result.length > 0 && result !== undefined) ? result[0].data : null;
        });
    }

    static async getDataFromDatabase(key, table) {
        let tableDatabase = dexie.Master;

        switch (table) {
            case SYNC_SERVICE.KRISHAK_TABLE:
                tableDatabase = dexie.Krishak;
                break;
            case SYNC_SERVICE.ACTIVITY_TABLE:
                tableDatabase = dexie.Activity;
                break;
            default:
                tableDatabase = dexie.Master;
                break;
        }
        return await tableDatabase.where("key").equalsIgnoreCase(key).toArray().then(function (result) {
            return (result.length === 0 || result === undefined) ? [] : result[0]?.data;
        });
    }


    // For Activities DATA
    static async addActivity(activity, data = null) {
        await dexie.Activity.put({
            key: activity?.key,
            activity_id: activity?.activity_id,
            activity_type_id: activity?.activity_type_id,
            activity_status_id: activity?.activity_status_id,
            assigned_user_id: activity?.assigned_user_id,
            crop_id: activity?.crop_id,
            hybrid_id: activity?.hybrid_id,
            village_id: activity?.village_id,
            krishak_id: activity?.krishak_id,
            temp_krishak_id: activity?.temp_krishak_id,
            retailer_id: activity?.retailer_id,
            stage_id: activity?.stage_id ? activity?.stage_id : 0,
            data: data,
            user_id: activity?.user_id,
            created_at: activity.created_at,
            is_active: 1,
            activity_reject: null,
            employee_id: String(activity?.assigned_user_id),
            last_sync_date: activity.is_synced === "true" ? Utilities.getSyncDate() : null,
            is_synced: activity?.is_synced
        });
    }

    static editActivity(data, isSynced) {
        Utilities.LogPrint("Edit Activity", data);
        const key = data?.key ? data?.key : String(data?.activity_id);
        dexie.Activity.update(key, {
            activity_id: data?.activity_id,
            activity_status_id: data?.activity_status_id,
            krishak_id: data?.krishak_id,
            temp_krishak_id: data?.temp_krishak_id,
            temp_krishak_phone: data?.temp_krishak_phone,
            retailer_id: data?.retailer_id,
            data: data,
            activity_reject: null,
            is_synced: isSynced,
            reporting_mobile: data.reporting_mobile,
            last_sync_date: Utilities.getSyncDate()
        });
    }


    static updateActivityWithServer(activity, isSynced) {
        Utilities.LogPrint("UpdateActivityWithServer", activity);
        //const key = activity?.key ? activity?.key : activity?.temp_activity_id;
        let key;
        if (activity?.temp_activity_id !== null) {
            key = activity?.temp_activity_id;
        } else {
            key = String(activity?.activity_id);
        }
        dexie.Activity.put({
            key: key,
            activity_id: activity?.activity_id,
            data: activity?.data,
            activity_type_id: activity?.activity_type_id,
            activity_status_id: activity?.activity_status_id,
            assigned_user_id: activity?.assigned_user_id,
            crop_id: activity?.crop_id,
            hybrid_id: activity?.hybrid_id,
            village_id: activity?.village_id,
            krishak_id: activity?.krishak_id,
            temp_krishak_id: 0,
            retailer_id: activity?.retailer_id,
            user_id: activity?.user_id,
            stage_id: activity?.stage_id,
            stage: activity?.activity_type_id === 4 ? activity.stage : null,
            activity_reject: activity?.activity_reject ? activity?.activity_reject : null,
            created_at: activity.created_at,
            is_active: activity?.is_active,
            employee_id: String(activity?.assigned_user_id),
            reporting_mobile: activity?.reporting_mobile,
            last_sync_date: activity.is_synced === "true" ? Utilities.getSyncDate() : null,
            is_synced: isSynced
        });
    }

    static updateActivityId(key, activityId) {
        Utilities.LogPrint("updateActivityId", activityId);
        dexie.Activity.update(key, {
            activity_id: activityId,
            is_synced: "true",
            //last_sync_date: Utilities.getSyncDate()
        });
    }

    static editActivityById(key, activityStatusId, data) {
        Utilities.LogPrint("updateActivityId", key);
        dexie.Activity.update(key, {
            activity_status_id: activityStatusId,
            data: data,
            is_synced: "false",
        });
    }

    static updateSyncStatus(key, isSynced) {
        Utilities.LogPrint("updateActivityId", key);
        dexie.Activity.update(key, {
            is_synced: isSynced,
        });
    }

    static updateActivityStatusId(key, activityStatusId, activityReject = null) {
        //Utilities.LogPrint("updateActivityStatusId Key", key);
        //Utilities.LogPrint("updateActivityStatusId", activityStatusId);
        //Utilities.LogPrint("updateActivityStatusId activityReject", activityReject);
        dexie.Activity.update(key, {
            activity_status_id: activityStatusId,
            activity_reject: activityReject,
            is_synced: "true"
        });
    }

    static editActivityWithServer(activity, isSynced) {
        //Utilities.LogPrint("Edit Activity", activity);
        const key = activity?.key ? activity?.key : String(activity?.activity_id);
        dexie.Activity.put({
            key: key,
            activity_id: activity?.activity_id,
            data: activity?.data,
            activity_type_id: activity?.activity_type_id,
            activity_status_id: activity?.activity_status_id,
            assigned_user_id: activity?.assigned_user_id,
            crop_id: activity?.crop_id,
            hybrid_id: activity?.hybrid_id,
            village_id: activity?.village_id,
            krishak_id: activity?.krishak_id,
            temp_krishak_id: 0,
            retailer_id: activity?.retailer_id,
            stage_id: 0,
            created_at: activity.created_at,
            is_active: 1,
            employee_id: String(activity?.assigned_user_id),
            activity_reject: null,
            last_sync_date: activity.is_synced === "true" ? Utilities.getSyncDate() : null,
            is_synced: isSynced
        });
    }

    static updateGroupMeetingMobileNumber(key, number) {
        Utilities.LogPrint("updateActivityId", key);
        dexie.Activity.update(key, {
            //activity_id: activityId,
            //is_synced: "true",
            reporting_mobile: number
        });
    }

    static async getActivities() {
        // return await dexie.Activity.toArray().then(function (result) {
        //    Utilities.LogPrint("All Today Activities", result);
        //     return result;
        // });

        // return await dexie.Activity.where("created_at").equalsIgnoreCase(new Date()).toArray().then(function (result) {
        //     Utilities.LogPrint("All Today Activities", result);
        //     return result;
        // });

        return await dexie.Activity.orderBy('activity_id').toArray().then(function (data) {
            let activities;
            let todayActivities = [];
            let pendingActivities = [];

            //Utilities.LogPrint("All Today Activities", data);
            if (data !== null && data?.length > 0) {
                data.forEach(element => {
                    if (element.is_active === 1) {
                        let item = Moment(element.created_at).format(DATE_FORMATS.DATE_FORMAT);
                        let todayDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);
                        //let todayDate = "2021-06-02";

                        if (item === todayDate) {
                            todayActivities.push(element);
                        } else {
                            var dateLimit = Moment(element.created_at);
                            var now = Moment();
                            if (now.isAfter(dateLimit)) {
                                if (element?.activity_status_id === ActivityStatusType.TO_START ||
                                    element?.activity_status_id === ActivityStatusType.TO_RESUBMIT) {
                                    pendingActivities.push(element);
                                }
                            }
                        }
                        activities = {
                            todayActivities: todayActivities,
                            pendingActivities: pendingActivities
                        }
                    }
                });
            }
            return activities;
        });
    }

    static async getActivityById(key, value) {
        return await dexie.Activity.where(key).equalsIgnoreCase(value).toArray().then(function (result) {
            //Utilities.LogPrint("getActivityById", result);
            return result[0];
        });
    }

    static updateDeleteActivity(key, isSynced = "false") {
        //Utilities.LogPrint("deleteLocalActivity", key);
        dexie.Activity.update(key, {
            is_active: 0,
            is_synced: isSynced,
        });
    }

    static deleteActivity(key) {
        dexie.Activity.delete(key);
    }

    static async getLocalActivities(key, value) {
        return await dexie.Activity.where(key).equalsIgnoreCase(value).toArray().then(function (result) {
            //Utilities.LogPrint("getLocalActivities", result);
            return (result && result.length > 0 && result !== undefined) ? result : null;
        });
    }


    static async addUserActivity(user) {
        //Utilities.LogPrint("Add User Activity", user);
        await dexie.UserActivity.put({
            key: uuidv4(),
            date: user?.date,
            userId: user.user_id,
            startTime: user?.start_time,
            startLocation: user?.start_location,
            endTime: null,
            endLocation: null,
        });
    }

    static async updateUserActivity(key, user) {
        //Utilities.LogPrint("updateUserActivity", user);
        await dexie.UserActivity.update(key, {
            endTime: user.end_time,
            endLocation: user.end_location
        });
    }

    static async getUserActivityByDate(date) {
        //Utilities.LogPrint("getUserActivityByDate", date);
        return await dexie.UserActivity.where("date").equalsIgnoreCase(date).toArray().then(function (result) {
            //Utilities.LogPrint("getUserActivityByDate", result);
            return (result && result.length > 0 && result !== undefined) ? result[0] : null;
        });
    }

    static async findActivityInDB(key) {
        return await dexie.Activity.get(key);
    }


    static async getFDOActivities() {
        return await dexie.Activity.orderBy('activity_id').toArray().then(function (data) {
            let todayActivities = [];

            //Utilities.LogPrint("All Today Activities", data);
            if (data !== null && data?.length > 0) {
                data.forEach(element => {
                    if (element.is_active === 1) {
                        let item = Moment(element.created_at).format(DATE_FORMATS.DATE_FORMAT);
                        let todayDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);

                        if (item === todayDate) {
                            todayActivities.push(element);
                        }
                    }
                });
            }
            //Utilities.LogPrint("TM Login============", todayActivities);
            return todayActivities;
        });
    }

    static async getFDOActivitiesById(userId) {
        return await dexie.Activity.where("employee_id").equalsIgnoreCase(String(userId)).sortBy('activity_id').then(function (data) {
            //Utilities.LogPrint("All Today Activities", data);

            if (data) {
                let activities;
                let todayActivities = [];
                let pendingActivities = [];

                const session = AuthService.getSession();

                //Utilities.LogPrint("FDO All Activities", data);
                if (data !== null && data?.length > 0) {
                    data.forEach(element => {
                        if (element.is_active === 1) {
                            let item = Moment(element.created_at).format(DATE_FORMATS.DATE_FORMAT);
                            let todayDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);

                            if (item === todayDate) {
                                todayActivities.push(element);
                            } else {

                                if (userId === session?.user?.user_id) {
                                    if (element?.activity_status_id === ActivityStatusType.TO_START) {
                                        pendingActivities.push(element);
                                    }
                                } else {
                                    if (element?.activity_status_id === ActivityStatusType.PENDING_REVIEW) {
                                        pendingActivities.push(element);
                                    }
                                }
                            }
                            activities = {
                                todayActivities: todayActivities,
                                pendingActivities: pendingActivities
                            }
                        }
                    });
                }
                return activities;
            }
        });
    }

    static async getTMActivitiesById(userId) {
        // const activities = await dexie.Activity.where('employee_id').equalsIgnoreCase(String(userId)).reverse().sortBy('activity_id');
        // Utilities.LogPrint("activities ===", activities);

        return await dexie.Activity.orderBy('activity_id').toArray().then(function (data) {
            let activities;
            let todayActivities = [];
            let pendingActivities = [];

            const session = AuthService.getSession();

            //Utilities.LogPrint("All Today Activities", data);
            if (data !== null && data?.length > 0) {
                data.forEach(element => {
                    if (element.is_active === 1 && element.user_id === userId) {
                        let item = Moment(element.created_at).format(DATE_FORMATS.DATE_FORMAT);
                        let todayDate = Moment(new Date()).format(DATE_FORMATS.DATE_FORMAT);

                        if (item === todayDate) {
                            todayActivities.push(element);
                        } else {
                            if (userId === session?.user?.user_id) {
                                if (element?.activity_status_id === ActivityStatusType.TO_START) {
                                    pendingActivities.push(element);
                                }
                            } else {
                                if (element?.activity_status_id === ActivityStatusType.PENDING_REVIEW) {
                                    pendingActivities.push(element);
                                }
                            }
                        }

                        activities = {
                            todayActivities: todayActivities,
                            pendingActivities: pendingActivities
                        }
                    }
                });
            }
            //Utilities.LogPrint("TM Login============", activities);
            return activities;
        });
    }

    static clearAllData() {
        //dexie.delete();
        dexie.Master.clear();
        dexie.Activity.clear();
        //dexie.UserActivity.clear();
        dexie.Krishak.clear();
        dexie.KrishakImages.clear();
    }


    static startSync(startCallback, endCallback) {
        //const startDateTime = new Date();

        this.masterCount = 0;
        this.krishakCount = 0;
        this.activityCount = 0;

        if (startCallback) {
            startCallback();
        }

        //Sync Logic 

        //const endDateTime = new Date();
        if (endCallback) {
            endCallback();
        }
    }

    static async deleteActivities() {
        await dexie.Activity.toArray().then(function (activities) {
            //Utilities.LogPrint("Delete Activities", activities);
            if (activities != null || activities?.length > 0) {
                for (let i = 0; i < activities.length; i++) {
                    const activity = activities[i];
                    if (activity.is_active === 0) {
                        SyncServices.deleteActivity(activity.key);
                        //Utilities.LogPrint("Delete Activity", activity);

                    }
                }

            }
            //return result;
        });
    }


    // For Sample To Sale Activities Sync
    static storeSampleToSaleById() {
        SyncServices.getLocalActivities("is_synced", "false").then(async activities => {
            //Utilities.LogPrint("S2S ===============", activities);

            if (activities != null || activities?.length > 0) {
                for (let i = 0; i < activities.length; i++) {
                    const activity = activities[i];
                    Utilities.LogPrint("s2s Activity", activity);

                    //const stage = activity?.stage;
                    //const currentStageId = activity?.stage_id;

                    if ((activity?.data?.history !== null && activity?.data?.history !== undefined) && Object.keys(activity?.data?.history).length > 0) {
                        if (activity?.activity_type_id === ActivityType.SAMPLE_TO_SALE) {

                            const session = AuthService.getSession();
                            const isTMLogin = session?.user.user_id === activity?.user_id ? true : false;
                            const activityStatusId = isTMLogin ? ActivityStatusType.COMPLETED : ActivityStatusType.PENDING_REVIEW;


                            const formData = new FormData();
                            formData.append("activity_id", activity.activity_id);
                            formData.append("stage_id", activity?.stage_id);
                            formData.append("activity_status_id", activityStatusId);

                            if (activity?.stage_id === S2S_STAGE.SOWING_AND_TRANSPLANTATION) {

                                const sowingStage = activity?.data?.history?.stage_one?.[0];
                                Utilities.LogPrint("SowingStage", sowingStage);

                                formData.append("sowing_date", sowingStage.sowing_date);
                                //formData.append("transplantation_date", sowingStage?.transplantation_date);
                                formData.append("irrigation_source_id", sowingStage?.irrigation_source_id);
                                formData.append("sowing_spacing_id", sowingStage?.sowing_spacing_id);
                                formData.append("stage_remark", sowingStage?.remark);
                                formData.append("latitude", sowingStage?.latitude);
                                formData.append("longitude", sowingStage?.longitude);

                                // For S2S Veg 
                                formData.append("row_spacing", sowingStage?.vc_sowing?.row_spacing);
                                formData.append("plant_spacing", sowingStage?.vc_sowing?.plant_spacing);

                                for (const image of sowingStage?.images) {
                                    if (image.image_id === 0) {
                                        formData.append("stage_image", image.file);
                                    }
                                }

                                // For Deleted Images
                                if (sowingStage?.deletedImages?.length > 0) {
                                    this.deleteServerImages(sowingStage?.deletedImages);
                                }

                            } else if (activity?.stage_id === S2S_STAGE.TRANSPLANTATION) {

                                const transplantationStage = activity?.data?.history?.stage_two?.[0];
                                Utilities.LogPrint("TransplantationStage", transplantationStage);

                                formData.append("transplantation_date", transplantationStage.transplantation_date);
                                formData.append("stage_remark", transplantationStage?.remark);
                                formData.append("latitude", transplantationStage?.latitude);
                                formData.append("longitude", transplantationStage?.longitude);

                                // For S2S Veg 
                                formData.append("row_spacing", transplantationStage?.vc_transplantation?.row_spacing);
                                formData.append("plant_spacing", transplantationStage?.vc_transplantation?.plant_spacing);

                                for (const image of transplantationStage?.images) {
                                    if (image.image_id === 0) {
                                        formData.append("stage_image", image.file);
                                    }
                                }

                                // For Deleted Images
                                if (transplantationStage?.deletedImages?.length > 0) {
                                    this.deleteServerImages(transplantationStage?.deletedImages);
                                }

                            } else if (activity?.stage_id === S2S_STAGE.PLOT_VISIT) {
                                const plotVisit = activity?.data?.history?.stage_three?.[0];

                                if (plotVisit !== undefined && plotVisit != null) {
                                    let plotVisitObj = {
                                        date: plotVisit?.date,
                                        crop_calendar_plot_visit_id: plotVisit?.crop_calendar_plot_visit_id,
                                        crop_plot_visit_crop_health_id: plotVisit?.crop_plot_visit_crop_health_id,
                                        crop_days_id: plotVisit?.crop_days_id,
                                    }
                                    formData.append("activity_plot_visits", JSON.stringify(plotVisitObj));
                                    formData.append("stage_remark", plotVisit?.remark);
                                    formData.append("latitude", plotVisit?.latitude);
                                    formData.append("longitude", plotVisit?.longitude);


                                    for (const image of plotVisit?.images) {
                                        if (image.image_id === 0) {
                                            formData.append("stage_image", image.file);
                                        }
                                    }

                                    // For Deleted Images
                                    if (plotVisit?.deletedImages?.length > 0) {
                                        this.deleteServerImages(plotVisit?.deletedImages);
                                    }
                                }

                            } else if (activity?.stage_id === S2S_STAGE.FIELD_DAY) {
                                const fieldDay = activity?.data?.history?.stage_four?.[0];
                                Utilities.LogPrint("FieldDay", fieldDay);
                                if (fieldDay !== undefined && fieldDay != null) {
                                    formData.append("field_days", fieldDay?.fieldDayObj);
                                    formData.append("latitude", fieldDay?.latitude);
                                    formData.append("longitude", fieldDay?.longitude);


                                    for (let i = 0; i < fieldDay?.farmerNumberImages.length; i++) {
                                        const objImage = fieldDay?.farmerNumberImages[i];
                                        if (objImage.image_id === 0) {
                                            formData.append("field_day_farmer_image", objImage.file);
                                        }
                                    }

                                    for (let i = 0; i < fieldDay?.images.length; i++) {
                                        const objImage = fieldDay?.images[i];
                                        if (objImage.image_id === 0) {
                                            formData.append("stage_image", objImage.file);
                                        }
                                    }

                                    // For Deleted Images
                                    if (fieldDay?.deletedImages?.length > 0) {
                                        this.deleteServerImages(fieldDay?.deletedImages);
                                    }
                                }

                            } else if (activity?.stage_id === S2S_STAGE.HARVEST_DETAILS) {
                                const harvest = activity?.data?.history?.stage_five?.[0];;
                                Utilities.LogPrint("Harvest", harvest);

                                if (harvest !== undefined && harvest != null) {
                                    const harvestObj = harvest?.harvestObj;
                                    Utilities.LogPrint("harvestObj", harvestObj);

                                    formData.append("harvests", harvestObj);
                                    formData.append("latitude", harvest.latitude);
                                    formData.append("longitude", harvest.longitude);
                                    formData.append("stage_remark", harvest.remark);

                                    for (let i = 0; i < harvest?.images.length; i++) {
                                        const objImage = harvest?.images[i];
                                        if (objImage.image_id === 0) {
                                            formData.append("stage_image", objImage.file);
                                        }
                                    }

                                    // For Deleted Images
                                    if (harvest?.deletedImages?.length > 0) {
                                        this.deleteServerImages(harvest?.deletedImages);
                                    }
                                }

                            } else if (activity?.stage_id === S2S_STAGE.GERMINATION) {
                                const germinationStage = activity?.data?.history?.stage_eight?.[0];;
                                Utilities.LogPrint("GerminationStage", germinationStage);

                                formData.append("germination", germinationStage.germination);
                                formData.append("stage_remark", germinationStage?.remark);
                                formData.append("latitude", germinationStage?.latitude);
                                formData.append("longitude", germinationStage?.longitude);


                                for (let i = 0; i < germinationStage?.images.length; i++) {
                                    const objImage = germinationStage?.images[i];
                                    if (objImage.image_id === 0) {
                                        formData.append("stage_image", objImage.file);
                                    }
                                }

                                // For Deleted Images
                                if (germinationStage?.deletedImages?.length > 0) {
                                    this.deleteServerImages(germinationStage?.deletedImages);
                                }

                            } else if (activity?.stage_id === S2S_STAGE.FRUIT_QUALITY) {
                                const fruitQualityStage = activity?.data?.history?.stage_nine?.[0];;
                                Utilities.LogPrint("FruitQualityStage", fruitQualityStage);

                                if (fruitQualityStage !== undefined && fruitQualityStage != null) {
                                    let fruitQuality = {
                                        fruit_uniformity: fruitQualityStage?.fruit_uniformity,
                                        fruit_color: fruitQualityStage?.fruit_color,
                                        fruit_length: fruitQualityStage?.fruit_length,
                                        fruit_girth: fruitQualityStage?.fruit_girth,
                                        fruit_weight: fruitQualityStage?.fruit_weight
                                    }
                                    formData.append("fruit_quality", JSON.stringify(fruitQuality));
                                    formData.append("stage_remark", fruitQualityStage?.remark);
                                    formData.append("latitude", fruitQualityStage?.latitude);
                                    formData.append("longitude", fruitQualityStage?.longitude);


                                    for (let i = 0; i < fruitQualityStage?.images.length; i++) {
                                        const objImage = fruitQualityStage?.images[i];
                                        if (objImage.image_id === 0) {
                                            formData.append("stage_image", objImage.file);
                                        }
                                    }

                                    // For Deleted Images
                                    if (fruitQualityStage?.deletedImages?.length > 0) {
                                        this.deleteServerImages(fruitQualityStage?.deletedImages);
                                    }
                                }

                            } else if (activity?.stage_id === S2S_STAGE.PEST_AND_DISEASE) {
                                const pestDiseaseStage = activity?.data?.history?.stage_ten?.[0];;
                                Utilities.LogPrint("PestDiseaseStage", pestDiseaseStage);

                                if (pestDiseaseStage !== undefined && pestDiseaseStage != null) {
                                    let pestDiseaseObj = {
                                        viral_disease: pestDiseaseStage.viral_disease,
                                        wilt: pestDiseaseStage.wilt,
                                        blight: pestDiseaseStage.blight
                                    }
                                    formData.append("pest_disease", JSON.stringify(pestDiseaseObj));
                                    formData.append("stage_remark", pestDiseaseStage?.remark);
                                    formData.append("latitude", pestDiseaseStage?.latitude);
                                    formData.append("longitude", pestDiseaseStage?.longitude);

                                    for (let i = 0; i < pestDiseaseStage?.images.length; i++) {
                                        const objImage = pestDiseaseStage?.images[i];
                                        if (objImage.image_id === 0) {
                                            formData.append("stage_image", objImage.file);
                                        }
                                    }

                                    // For Deleted Images
                                    if (pestDiseaseObj?.deletedImages?.length > 0) {
                                        this.deleteServerImages(pestDiseaseObj?.deletedImages);
                                    }
                                }
                            }

                            const fieldDamage = activity?.data?.history?.stage_six?.[0];
                            if (fieldDamage !== undefined && fieldDamage != null) {

                                let fieldDamageObj = {
                                    field_damage: fieldDamage?.field_damage,
                                    field_damage_reason_id: fieldDamage?.field_damage_reason_id
                                }
                                formData.append("field_damage", JSON.stringify(fieldDamageObj));
                                formData.append("field_damage_remark", fieldDamage.remark);

                                for (let i = 0; i < fieldDamage?.images.length; i++) {
                                    const objImage = fieldDamage?.images[i];
                                    if (objImage.image_id === 0) {
                                        formData.append("field_damage_image", objImage.file);
                                    }
                                }
                            }

                            try {
                                await ApiServices.storeSampleToSaleById(formData)
                                    .then(response => {
                                        Utilities.LogPrint("API_DATA: ---->", response);
                                        if (response.success) {
                                            //const data = response.data;
                                            SyncServices.updateSyncStatus(activity.key, "true");

                                        } else {
                                            Utilities.LogPrint("Status", response.message);
                                            if (response.message !== undefined && response.message) {
                                                this.setState({
                                                    errorMsg: response.message
                                                });
                                            }
                                        }
                                    }).catch(error => {
                                        Utilities.LogPrint("Error: ---->", error);
                                    });
                            } catch (error) {
                                Utilities.LogPrint("Error: ---->", error);
                            }
                        }
                    }
                }
            }
        });
    }


    // For Delete Server Images
    static deleteServerImages(deletedImages) {
        Utilities.LogPrint("DeletedImages", deletedImages);

        if (deletedImages?.length > 0) {
            const formData = new FormData();
            let lst_sync = [{
                action: SYNC_SERVICE.ACTION_DELETE_STAGE_IMAGE,
                last_sync_date: "",
                data: deletedImages
            }]
            formData.append("lst_sync", JSON.stringify(lst_sync));
            try {
                ApiServices.syncData(formData).then(response => {
                    Utilities.LogPrint("API_DATA syncData: ---->", response);
                    if (response.success) {
                    }
                }).catch(error => {
                    Utilities.LogPrint("Status-Catch", error);
                });
            } catch (error) {
                Utilities.LogPrint("Status-Catch", error);
            }
        }

    }

    static async getLocalKrishakCount() {
        return await SyncServices.getKrishakFromDatabase("is_synced", "false").then(data => {
            if (data && data.length > 0) {
                return data.length;
            } else {
                return 0;
            }
        });
    }

    static async getLocalActivityCount() {
        return await SyncServices.getLocalActivities("is_synced", "false").then(activities => {
            if (activities && activities.length > 0) {
                return activities.length;
            } else {
                return 0;
            }
        });
    }

    static async getAllKrishak() {
        return await dexie.Krishak.toArray().then(function (result) {
            Utilities.LogPrint("getAllKrishak", result);
            return result;
        });
    }
}